//TODO create .env file!
export const weatherApiKey = "a4a2d20aac06964ab8aaf0a6346445eb";
